import React, { useCallback, useMemo, useState } from 'react';
import { useField } from 'react-final-form';
import { Checkbox } from 'ksnm-common-ui/lib/Checkbox';
import { Icon } from 'ksnm-common-ui/lib/Icon';
import { Input } from 'ksnm-common-ui/lib/Input';
import { debounce } from 'lodash-es';

import type { ControlVersionWithNameDtoWitId } from '@stores/passingControlStore';

import styles from './ControlVersionsList.module.scss';

export const ControlVersionsList = ({
  uncreatedControlVersions,
}: {
  uncreatedControlVersions: ControlVersionWithNameDtoWitId[];
}): React.ReactElement | null => {
  const [input, setInput] = useState<string>('');

  const {
    input: { onChange: onChangeControlVersions, value: controlVersions },
  } = useField('controlVersions');

  const onChange = useCallback(
    (value) => {
      if (controlVersions.includes(value)) {
        return onChangeControlVersions([...controlVersions.filter((el) => el !== value)]);
      } else {
        return onChangeControlVersions([...controlVersions, value]);
      }
    },
    [controlVersions, onChangeControlVersions],
  );

  const onChangeAll = useCallback(
    (event) => {
      onChangeControlVersions(event.target.checked ? [...uncreatedControlVersions.map((item) => item.id)] : []);
    },
    [onChangeControlVersions, uncreatedControlVersions],
  );

  const debouncedInput = debounce((value: string) => {
    setInput(value);
  }, 300);

  const filterUncreatedControlVersions = useMemo(
    () => uncreatedControlVersions.filter((item) => item.name?.includes(input)),
    [input, uncreatedControlVersions],
  );

  if (!uncreatedControlVersions.length) return null;

  return (
    <div>
      <div className={styles.wrapper}>
        <Checkbox onChange={onChangeAll} checked={controlVersions.length === uncreatedControlVersions.length} />
        <Input
          placeholder="Введите текст"
          onChange={debouncedInput}
          size="small"
          allowClear={false}
          className={styles.input}
        />
        <Icon name="search" className={styles.icon} fill="#547DB1" />
      </div>

      <div className={styles.list}>
        {filterUncreatedControlVersions.map((item) => (
          <Checkbox onChange={() => onChange(item.id)} checked={controlVersions.includes(item.id)} key={item.id}>
            {item.controlVersExt} - {item.controlName}
          </Checkbox>
        ))}
      </div>
    </div>
  );
};
